<template>
  <div>

    <el-dialog
        v-if="currentRow"
        :title="'CRO (clinical research organisation) ' + currentRow.title + (currentRow.id ? ' bearbeiten' : ' hinzufügen')"
        v-model="showEditForm">
      <el-row class="mt-4">
        <el-col :span="24">
          <h6>Bezeichnung</h6>
          <el-input
              placeholder="Bezeichnung"
              v-model="currentRow.title"></el-input>
        </el-col>
      </el-row>
      <el-row class="mt-4">
        <el-col :span="24">
          <h6>Link zum eCRF Portal</h6>
          <el-input
            placeholder="Link eCRF Portal"
            v-model="currentRow.ecrf_link"></el-input>
        </el-col>
      </el-row>

      <template #footer>
        <el-row>
          <el-col :span="10" class="text-left">
            <el-popconfirm
                v-if="currentRow.id"
                title="Sie möchten diese CRO löschen?"
                confirmButtonText='Ja, löschen'
                confirmButtonType="danger"
                cancelButtonText='Nein'
                iconColor="red"
                @confirm="onRowDeleteConfirmed(currentRow)">
              <template #reference>
                <el-button type="danger">Löschen</el-button>
              </template>
            </el-popconfirm>
          </el-col>
          <el-col :span="14" class="dialog-footer text-right">
            <el-button @click="showEditForm = false">Abbrechen</el-button>
            <el-button type="primary" @click="saveRow()">{{(currentRow.id ? ' Speichern' : 'Hinzufügen')}}</el-button>
          </el-col>
        </el-row>

      </template>
    </el-dialog>

    <el-button type="primary" @click="onBtnNewClick" size="mini" icon="el-icon-circle-plus">CRO hinzufügen</el-button>

    <el-table
        ref="croTable"
        :data="tableData"
        :default-sort = "{prop: 'title', order: 'ascending'}"
        style="width: 100%"
        highlight-current-row
        @row-click="onRowEditClick"
        stripe>
      <el-table-column
          prop="title"
          label="Titel"
          sortable>
      </el-table-column>
      <el-table-column
          width="150">
        <template #default="scope">
          <div class="text-right">
            <el-button size="mini" type="warning" @click="onRowEditClick(scope.row)" icon="el-icon-edit"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          width="70">
        <template #default="scope">
          <div class="text-right">
            <el-popconfirm
                :title="'Sie möchten diese CRO löschen?'"
                confirmButtonText='Ja, löschen'
                confirmButtonType="danger"
                cancelButtonText='Nein'
                iconColor="red"
                @confirm="onRowDeleteConfirmed(scope.row)">
              <template #reference>
                <el-button size="mini" type="warning" icon="el-icon-delete"></el-button>
              </template>
            </el-popconfirm>

          </div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
const _ = require('lodash');

export default {
  name: "SettingCRO",
  props: [],
  components: {},
  data() {
    return {
      tableData: [],
      currentRow: null,
      showEditForm: false
    }
  },
  mounted: async function () {
    await this.getCRO()
  },
  computed: {
    ...mapGetters('cro', ['cro']),
  },
  watch: {
    cro: function (val) {
      this.tableData = _.cloneDeep(val)
    }
  },
  methods: {
    ...mapActions('cro', ['getCRO', 'deleteCRO', 'saveCRO']),
    async onRowDeleteConfirmed(row) {
      await this.deleteCRO(row)
      this.showEditForm = false
      await this.getCRO()
    },
    onBtnNewClick() {
      this.currentRow = {
        id: null,
        title: ''
      }
      this.showEditForm = true

    },
    onRowEditClick(row) {
      this.currentRow = row
      this.showEditForm = true
    },
    async saveRow() {
      await this.saveCRO(this.currentRow)
      this.showEditForm = false
      await this.getCRO()
    }
  }
}
</script>
<style scoped>
</style>
